import { Component, Input } from '@angular/core'
import { IDataCardNotification } from '../../../../../../models/data-card.model'
import { NzDrawerService } from 'ng-zorro-antd/drawer'
import { MainObjectDataCardTemplateComponent } from '../../../main-object-data-card-template/main-object-data-card-template.component'
import { HelperService } from "../../../../../../services/helper.service"

@Component({
    selector: 'app-data-notification',
    templateUrl: './data-notification.component.html',
    standalone: false
})
export class DataNotificationComponent {
  @Input() data: IDataCardNotification
  @Input() isLoading: boolean = false

  public constructor(private drawerService: NzDrawerService) {}

  public onDataCardDrawerOpen(mainObject: string): void {
    this.drawerService.create<MainObjectDataCardTemplateComponent, { mo: string }, any>({
      nzTitle: 'Datacard',
      nzWidth: '500px',
      nzContent: MainObjectDataCardTemplateComponent,
      nzData: { mo: mainObject },
    })
  }

  public hasReportRepairDescription(): boolean {
    return this.data
      && !HelperService.isNullOrUndefined(this.data.repair_report_description)
      && this.data.repair_report_description.toString().length > 0
  }
}
